import React from "react";
import "./Home3.css";

const Home3 = () => {
  return (
    <div className="home3">
      <h1>Instagram</h1>
      <iframe
        title="Instagram Feed"
        src="https://widget.tagembed.com/293765?website=1"
        style={{
          width: "100%",
          height: "100%",
          overflow: "auto",
          border: "none",
        }}
      ></iframe>
    </div>
  );
};

export default Home3;
